import script from "./[tab].vue?vue&type=script&setup=true&lang=ts"
export * from "./[tab].vue?vue&type=script&setup=true&lang=ts"

import "./[tab].vue?vue&type=style&index=0&id=2c8e5cf4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c8e5cf4"]])

export default __exports__